import React, { Component } from 'react';
import { Row, Col, Navbar, Nav, NavItem, NavDropdown, MenuItem, Image, Alert, Button } from 'react-bootstrap';
import LoginContainer from "./LoginContainer.jsx";
import hyperlinks from "../../../src/util/hyperlinks";
import linkedin from '../../assets/images/icons/linkedin_icon.svg';
import twitter from '../../assets/images/icons/twitter.svg';
import Footer from './Footer.jsx.erb';



const rawNavItems = [
    { title: "Home", href: hyperlinks["home"] },
    { title: "About", href: hyperlinks["aboutUs"] },
    { title: "Membership", href: hyperlinks["membership"] },
    { title: "Innovation Areas", href: hyperlinks["innovationAreas"] },
    { title: "Events", href: hyperlinks["events"] },
    { title: "Contact", href: hyperlinks["contactUs"] }
];

const rawDropdownNavItems = {
    About: [
        { title: "Press releases", href: hyperlinks["pressReleases"] }
    ],
    Membership: [
        { title: "Utility members", href: hyperlinks["membership"] },
        { title: "Corporate members", href: hyperlinks["corporateMembership"] },
        { title: "Become a member", href: hyperlinks["newMember"] },
        { title: "The Board", href: hyperlinks["advisoryBoard"] },
    ],
    Events: [
        { title: "Events overview", href: hyperlinks["eventsOverview"] },
        { title: "Workshops", href: hyperlinks["workshops"] }
    ],
};

let rawSideDropdownNavItems;

const alertMapping = {
    notice: "success",
    alert: "danger"
};

export default class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeKey: 0,
            flashes: this.props.flashes || {},
            userChannels: this.props.currentUser ? this.props.currentUser.user_channels : []
        };
        this.setActiveKey = this.setActiveKey.bind(this);
        this.terminateFlashes = this.terminateFlashes.bind(this);
    }

    componentWillMount() {
        this.setActiveKey();
        rawSideDropdownNavItems = {
            "Utility members": [
                { title: "See members", href: hyperlinks["currentMembers"] }
            ],
            "Corporate members": [
                { title: "Foundation partner", href: hyperlinks["foundationPartner"] },
                { title: "Corporate Members", href: hyperlinks["corporateMembers"] }
            ]
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.terminateFlashes();
        }, 4000);

        // Notify if new message
        if (this.props.currentUser && window.location.pathname != hyperlinks["messages"]) {
            window.addEventListener("newMessage", e => {
                const message = e.detail.message;
                if (!this.state.userChannels.map(userChannel => userChannel.channel_id).includes(message.channel_id) || message.user_id == this.props.currentUser.id) return;
                let userChannels = Object.assign([], this.state.userChannels);
                const relevantUserChannel = userChannels.find(userChannel => userChannel.channel_id == message.channel_id);
                relevantUserChannel.unread_message_count ++;
                const channelIndex = userChannels.indexOf(relevantUserChannel);
                userChannels[channelIndex] = relevantUserChannel;

                this.setState({ userChannels: userChannels });
            });
        }
    }

    setActiveKey() {
        let bestMatch = [""];
        let activeKey;
        if (location.pathname == "/") {
            const activeItem = rawNavItems.find(item => item.title == "Home");
            activeKey = rawNavItems.indexOf(activeItem) + 1;
        } else if (location.pathname == hyperlinks["corporateMembers"]) {
            const activeItem = rawNavItems.find(item => item.title == "Partners");
            activeKey = rawNavItems.indexOf(activeItem) + 1;
        } else {
            rawNavItems.forEach((item, i) => {
                let match = location.pathname.match(item.href);
                if (match && match[0].length > bestMatch[0].length) {
                    bestMatch = match;
                    activeKey = i + 1;
                    return;
                }
            });
        }
        this.setState({ activeKey: activeKey });
    }

    terminateFlashes() {
        if (!Object.keys(this.state.flashes).length) return;
        const flashDivs = Array.from(document.querySelector(".flashes").children);
        flashDivs.forEach(div => {
            div.className += " fade";
        });
        setTimeout(() => {
            this.setState({ flashes: [] });
        }, 1000);
    }

    render() {
        const navItems = rawNavItems.map((navItem, i) => {
            if (rawDropdownNavItems[navItem.title]) {
                const menuItems = rawDropdownNavItems[navItem.title].map((menuItem, j) => {
                    if (rawSideDropdownNavItems[menuItem.title]) {
                        const sideOptions = rawSideDropdownNavItems[menuItem.title].map((sideMenuItem, k) => {
                            return (
                                <li role="presentation" key={`side-option${k + 1}`}>
                                    <a href={sideMenuItem.href}>{sideMenuItem.title}</a>
                                </li>
                            );
                        });
                        return (
                            <li key={`navItem${j + 1}`} role="presentation">
                                <a href={menuItem.href} role="menuitem" tabIndex="-1">{menuItem.title}</a>
                                <ul className={`side-dropdown-menu-${j + 1}`} aria-labelledby={`${menuItem.title}-dropdown`}>
                                    {sideOptions}
                                </ul>
                            </li>
                        );
                    } else {
                        return <MenuItem key={`navItem${j + 1}`} eventKey={Number(`${j + 1}.${j + 1}`)} href={menuItem.href}>{menuItem.title}</MenuItem>;
                    }
                });
                if(navItem.title == 'Events') {
                    return (
                        <NavDropdown key={`navItem${i + 1}`} eventKey={i + 1} title={navItem.title} href="#" id={`${navItem.title}-dropdown`} className="events-toggle">
                            {menuItems}
                        </NavDropdown>
                    );
                }
                return (
                    <NavDropdown key={`navItem${i + 1}`} eventKey={i + 1} title={navItem.title} href={navItem.href} id={`${navItem.title}-dropdown`}>
                        {menuItems}
                    </NavDropdown>
                );
            } else {
                return <NavItem key={`navItem${i + 1}`} eventKey={i + 1} href={navItem.href}>{navItem.title}</NavItem>;
            }
        });

        let flashes;
        const flashKeys = Object.keys(this.state.flashes);
        if (flashKeys.length) {
            flashes = flashKeys.map((key, i) => {
                return <Alert bsStyle={alertMapping[key]} key={`flash${i + 1}`}>{this.state.flashes[key]}</Alert>;
            });
        }

        return (
            <div className="wrap">
                <LoginContainer currentUser={this.props.currentUser} />

                <a href={hyperlinks["home"]}>
                    <Image src="/assets/logo-full-blue-3ce79e67a864f2c62d4d3b0c2cbd21e771e699165ee781eadb9efb2c8af30bcc.svg" className="nav-logo" />
                </a>
                <Navbar>
                    <Navbar.Header>
                        <Navbar.Toggle />
                    </Navbar.Header>
                    <Navbar.Collapse>
                        <Row>
                            <Col md={12}>
                                <Nav activeKey={this.state.activeKey}>
                                    {navItems}
                                    <div className="logo-container">
                                        <a
                                          href="https://www.linkedin.com/showcase/leading-utilities-of-the-world"
                                          target="_blank"
                                          className="social-icon-wrapper"
                                        >
                                          <Image src={linkedin} className="social-icon" alt="Follow us on linkedin" />
                                        </a>
                                        <a
                                          href="https://www.twitter.com/waterleaders"
                                          target="_blank"
                                          className="social-icon-wrapper"
                                        >
                                          <Image src={twitter} className="social-icon" alt="Follow us on twitter" />
                                        </a>
                                    </div>
                                </Nav>
                            </Col>
                                  
                        </Row>
                    </Navbar.Collapse>
                </Navbar>
                <div className="flashes">{flashes}</div>
                {this.props.children}
                <Footer />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/Header.jsx.erb